import { Button } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { Input, Label } from "reactstrap";
import Select from "react-select";
import { options } from "./options";
import { ApiPut } from "../../../../../helpers/API/ApiData";
import { toast } from "react-toastify";
import axios from "axios";
import moment from "moment";
import { validationString } from "./validation";
import "./LeadModel.scss";

const LeadModel = ({ lead, handleModel, handleGetDashboardCount, setZoom }) => {
  console.log("lead", lead);
  const [updatedData, setUpdatedData] = useState(lead);
  const [error, setError] = useState({});

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setUpdatedData({ ...updatedData, [name]: value });
    setError({ ...error, [name]: "" });
  };

  const commonRequiredfield = {
    productId: 2,
    utm_source: "WePro Deutschland GmbH",
    utm_medium: "affiliate",
    // company: "Mustermann GmbH",
  };

  const housetype = {
    Einfamilienhaus: "Ein-/Zweifamilienhaus",
    Reihenhaus: "Ein-/Zweifamilienhaus",
    Doppelhaushälfte: "Ein-/Zweifamilienhaus",
    Mehrfamilienhaus: "Mehrfamilienhaus",
    Garage: "Sonstiges",
    Anderes: "Sonstiges",
  };
  useEffect(() => {
    setModelValue();
  }, []);
  const setModelValue = () => {
    const arrayData = updatedData?.schornstein?.map((item) => {
      const obj = {
        value: item,
        label: item,
      };
      return obj;
    });

    const payload = {};

    for (const [key, value] of Object.entries(updatedData)) {
      const keyArray = [
        "housetype",
        "satteldach",
        "roofFelt",
        "aktuellkeineAuto",
        "rooftype",
      ];
      if (keyArray.includes(key)) {
        payload[key] = { value: value, label: value };
      }
    }

    setUpdatedData({ ...updatedData, ...payload, schornstein: arrayData });
  };

  const handleSelect = (data, name) => {
    setUpdatedData({ ...updatedData, [name]: data });
    setError({ ...error, [name]: "" });
  };

  console.log("updatedData", updatedData);
  const updloadData = async () => {
    const { isValid, errors } = validationString(updatedData);
    setError(errors);

    if (isValid) {
      try {
        let payload = {};
        for (const [key, value] of Object.entries(updatedData)) {
          if (
            key !== "locationCoordinates" &&
            key !== "userLocationCoordinates"
          ) {
            if (Array.isArray(value)) {
              const data = value.map((item) => item.value);
              payload[key] = data;
            } else if (
              value &&
              typeof value === "object" &&
              value.label &&
              value.value
            ) {
              payload[key] = value.value;
            } else {
              payload[key] = value;
            }
          }
        }
        payload["infoType"] = false;
        payload["newStraperMapLead"] = false;
        await ApiPut(
          `straper/updateStraperLead?id=${updatedData._id}`,
          payload
        ).then((resp) => {
          let watfoxApiData = resp?.data?.payload;
          let stepperId = resp?.data?.payload?._id;
          let formattedDate = moment(watfoxApiData.createdAt)
            .tz("Europe/Paris")
            .format("DD.MM.YYYY HH:mm:ss");
          const logindata = {
            user: "wepro-deutschland-import-live-api",
            pass: "U42xB8a!LjkRU6FtN56K",
          };

          axios
            .post(
              "https://api-v1.photovoltaik-angebotsvergleich.de/v1/login",
              logindata
            )
            .then(async (response) => {
              let straper = [];
              let token = response?.data?.auth_token;
              const salutation =
                watfoxApiData?.contractions === "Familie"
                  ? "Herr"
                  : watfoxApiData?.contractions;
              const data = {
                ...commonRequiredfield,
                salutation: salutation,
                zip: watfoxApiData?.pLZ,
                city: watfoxApiData?.location,
                street: watfoxApiData?.strabe,
                phone: watfoxApiData?.telephon,
                country: "DE",
                firstname: watfoxApiData?.name,
                lastname: watfoxApiData?.nachname,
                ph_artdesgebaeude: housetype[watfoxApiData?.housetype],
                email: watfoxApiData?.email,
                utm_campaign: `Door to Door,${watfoxApiData.location},${formattedDate},${watfoxApiData.userId}`,
                stromverbrauch: watfoxApiData?.power_consumption,
                notes: `${
                  watfoxApiData?.notizen !== "undefined"
                    ? `${watfoxApiData?.notizen},`
                    : ""
                }${
                  watfoxApiData?.satteldach
                } , ${watfoxApiData?.schornstein.toString()}`,
                tracking: {
                  pb_ingenious_amc: watfoxApiData?.uniqueTrackingId,
                },
              };
              axios
                .post(
                  "https://api-v1.photovoltaik-angebotsvergleich.de/v1/leads",
                  data,
                  {
                    headers: {
                      "Content-Type": "application/json",
                      "X-AUTH-TOKEN": token,
                    },
                  }
                )
                .then((newresp) => {
                  let wf_leadid = newresp?.data?.wf_leadid;
                  let body = {
                    wf_leadid: wf_leadid,
                    leadType: "wattfox-normal",
                  };

                  ApiPut(`straper/updateStraperStatus?id=${stepperId}`, body)
                    .then((resp) => {})
                    .catch((error) => {
                      console.log(error);
                    });
                })
                .catch((err) => {
                  console.log(err);
                });
            })
            .catch((error) => {
              toast.error("Invalid login credentials");
              console.log(error);
            });
        });

        toast.success("sucessfully updated");
        await handleModel();
        await handleGetDashboardCount();
        await handleModel(payload);
      } catch (error) {
        console.error("Something went wrong!");
      }
    }
  };

  return (
    <>
      <Modal.Header
        className="justify-content-start d-flex align-items-center"
        closeButton
      >
        <h1> Lead Information </h1>
      </Modal.Header>
      <Modal.Body>
        <div class="row pb-3">
          <div className="col-4 col-md-4">
            <Label className="form-label" for="name">
              Vorname
            </Label>
            <Input
              placeholder="Benutzername"
              name="name"
              className="input-mod"
              value={updatedData?.name}
              onChange={(e) => handleOnChange(e)}
            />
            <span className="error-lead">{error?.name}</span>
          </div>
          <div className="col-4 col-md-4">
            <Label className="form-label" for="nachname">
              Nachname
            </Label>
            <Input
              placeholder="Nachname"
              className="input-mod"
              name="nachname"
              value={updatedData?.nachname}
              onChange={(e) => handleOnChange(e)}
            />
            <span className="error-lead">{error?.nachname}</span>
          </div>

          <div className="col-4 col-md-4">
            <Label className="form-label" for="Strabe">
              Straße
            </Label>
            <Input
              placeholder="Straße"
              className="input-mod"
              name="strabe"
              value={updatedData?.strabe}
              onChange={(e) => handleOnChange(e)}
            />
            <span className="error-lead">{error?.strabe}</span>
          </div>
        </div>
        <div class="row pb-3">
          <div className="col-4 col-md-4">
            <Label className="form-label" for="name">
              Ort
            </Label>
            <Input
              placeholder="Ort"
              name="location"
              className="input-mod"
              value={updatedData?.location}
              onChange={(e) => handleOnChange(e)}
            />
            <span className="error-lead">{error?.location}</span>
          </div>
          <div className="col-4 col-md-4">
            <Label className="form-label" for="pLZ">
              PLZ
            </Label>
            <Input
              placeholder="PLZ"
              name="pLZ"
              className="input-mod"
              value={updatedData?.pLZ}
              onChange={(e) => handleOnChange(e)}
            />
            <span className="error-lead">{error?.pLZ}</span>
          </div>
          <div className="col-4 col-md-4">
            <Label className="form-label" for="telephon">
              Telefon
            </Label>
            <Input
              placeholder="Telefon"
              name="telephon"
              className="input-mod"
              value={updatedData?.telephon}
              onChange={(e) => handleOnChange(e)}
            />
            <span className="error-lead">{error?.telephon}</span>
          </div>
        </div>
        <div class="row pb-3">
          <div className="col-4 col-md-4">
            <Label className="form-label" for="email">
              E-Mail
            </Label>
            <Input
              placeholder="E-Mail"
              name="email"
              className="input-mod"
              value={updatedData?.email}
              onChange={(e) => handleOnChange(e)}
            />
            <span className="error-lead">{error?.email}</span>
          </div>
          <div className="col-4 col-md-4">
            <Label className="form-label" for="Stromverbrauch">
              Stromverbrauch
            </Label>
            <Input
              placeholder="Stromverbrauch"
              name="power_consumption"
              className="input-mod"
              value={updatedData?.power_consumption}
              onChange={(e) => handleOnChange(e)}
            />
            <span className="error-lead">{error?.power_consumption}</span>
          </div>
          <div className="col-4 col-md-4">
            <Label className="form-label" for="Einfamilienhaus">
              Hausart
            </Label>
            <div>
              <Select
                className="Select-main"
                options={options["housetype"]}
                placeholder="Hausart"
                value={updatedData?.housetype}
                name="housetype"
                onChange={(e) => handleSelect(e, "housetype")}
              />
              <span className="error-lead">{error?.housetype}</span>
            </div>
          </div>
        </div>
        <div class="row pb-3">
          <div className="col-4 col-md-4">
            <Label className="form-label" for="Satteldach">
              Dachart
            </Label>
            <div>
              <Select
                className="Select-main"
                options={options["satteldach"]}
                placeholder="Satteldach"
                value={updatedData?.satteldach}
                name="satteldach"
                onChange={(e) => handleSelect(e, "satteldach")}
              />
              <span className="error-lead">{error?.satteldach}</span>
            </div>
          </div>

          <div className="col-4 col-md-4">
            <Label className="form-label" for="roofFelt">
              Dachbelegung
            </Label>
            <div>
              <Select
                className="Select-main"
                options={options["roofFelt"]}
                placeholder="Dachbelegung"
                value={updatedData?.roofFelt}
                name="roofFelt"
                onChange={(e) => handleSelect(e, "roofFelt")}
              />
              <span className="error-lead">{error?.roofFelt}</span>
            </div>
          </div>

          <div className="col-4 col-md-4">
            <Label className="form-label" for="schornstein">
              Störfaktoren
            </Label>
            <div>
              <Select
                className="Select-main"
                options={options["schornstein"]}
                placeholder="Störfaktoren"
                isMulti
                value={updatedData?.schornstein}
                name="schornstein"
                onChange={(e) => handleSelect(e, "schornstein")}
              />
              <span className="error-lead">{error?.schornstein}</span>
            </div>
          </div>
        </div>

        <div class="row pb-3">
          <div className="col-4 col-md-4">
            <Label className="form-label" for="E-Auto vorhanden">
              E-Auto
            </Label>
            <div>
              <Select
                className="Select-main"
                options={options["aktuellkeineAuto"]}
                placeholder="E-Auto"
                value={updatedData?.aktuellkeineAuto}
                name="aktuellkeineAuto"
                onChange={(e) => handleSelect(e, "aktuellkeineAuto")}
              />
              <span className="error-lead">{error?.aktuellkeineAuto}</span>
            </div>
          </div>
          <div className="col-4 col-md-4">
            <Label className="form-label" for="roofFelt">
              Wärmepumpe
            </Label>
            <div>
              <Select
                className="Select-main"
                options={options["rooftype"]}
                placeholder="Wärmepumpe"
                value={updatedData?.rooftype}
                name="rooftype"
                onChange={(e) => handleSelect(e, "rooftype")}
              />
              <span className="error-lead">{error?.rooftype}</span>
            </div>
          </div>

          <div className="col-4 col-md-4">
            <Label className="form-label" for="wichtige Informationen">
              Informationen
            </Label>
            <Input
              name="notizen"
              placeholder="Informationen"
              className="input-mod"
              value={updatedData?.notizen}
              onChange={(e) => handleOnChange(e)}
            />
          </div>
        </div>
        <div class="row pb-3">
          <div className="col-4 col-md-4">
            <Label className="form-label" for="wichtige Informationen">
              Kommentar
            </Label>
            <Input
              name="comment"
              placeholder="Kommentar"
              className="input-mod"
              value={updatedData?.comment}
              onChange={(e) => handleOnChange(e)}
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          className="activebutton h-40px"
          style={{ marginRight: "15px" }}
          onClick={handleModel}
        >
          Abbrechen
        </Button>
        <Button className="addbutton" onClick={updloadData}>
          <span>{" LEAD ABSENDEN"}</span>
        </Button>
      </Modal.Footer>
    </>
  );
};

export default LeadModel;
